import React, { useEffect, useState } from "react";
import Dropdown from "../dropdown/index";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import avatar from "../../../assets/img/avatar4.png";
import axios from "axios";
import { toast } from "react-toastify";

const Navbar = (props) => {
	const { onOpenSidenav, brandText } = props;
	const [darkmode, setDarkmode] = React.useState(false);
	const navigate = useNavigate();
	const [users, setUsers] = useState([]);

	useEffect(() => {
		const token = localStorage.getItem("token");
		const id = localStorage.getItem("id");

		if (token) {
			if (id) {
				const fetchUsersData = async () => {
					try {
						const response = await axios.get(`/api_w/users/${id}`, {
							headers: {
								db_name: process.env.REACT_APP_DB_NAME,
							},
						});
						setUsers(response.data.data);
					} catch (error) {
						toast.error(error.response?.data?.message || error.message);
					}
				};

				fetchUsersData();
			}
		}
	}, [navigate]);

	const handleLogout = async () => {
		const isConfirmed = window.confirm("Apakah Anda yakin ingin logout?");
		if (!isConfirmed) return;

		try {
			await axios.delete("/api_w/users/logout", {
				headers: {
					Authorization: `${localStorage.getItem("token")}`,
					db_name: process.env.REACT_APP_DB_NAME,
				},
			});
		} catch (error) {
			console.error("Logout API error:", error);
		} finally {
			localStorage.removeItem("token");
			localStorage.removeItem("id");
			localStorage.removeItem("role");
			navigate("/");
		}
	};

	const isValidImage = (url) => {
		const validExtensions = ["jpeg", "jpg", "png", "webp", "svg"];
		const extension = url.split(".").pop().toLowerCase();
		return validExtensions.includes(extension);
	};

	const profileImage =
		users.profile_pict && isValidImage(users.profile_pict)
			? users.profile_pict
			: avatar;

	return (
		<nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
			<div className="ml-[6px]">
				<div className="h-6 w-[224px] pt-1">
					<a
						className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
						href=" "
					>
						Pages
						<span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
							{" "}
							/{" "}
						</span>
					</a>
					<Link
						className="text-sm font-bold capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
						to="#"
					>
						{brandText}
					</Link>
				</div>
			</div>

			<div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
				<div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
					<p className="pl-3 pr-2 text-xl">
						<FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
					</p>
					<input
						type="text"
						placeholder="Search..."
						className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
					/>
				</div>
				<span
					className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
					onClick={onOpenSidenav}
				>
					<FiAlignJustify className="h-5 w-5" />
				</span>
				<div
					className="cursor-pointer text-gray-600"
					onClick={() => {
						if (darkmode) {
							document.body.classList.remove("dark");
							setDarkmode(false);
						} else {
							document.body.classList.add("dark");
							setDarkmode(true);
						}
					}}
				>
					{darkmode ? (
						<RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
					) : (
						<RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
					)}
				</div>
				{/* Profile & Dropdown */}
				<Dropdown
					button={
						<img
							className="h-10 w-10 rounded-full"
							src={profileImage}
							alt={users.name}
						/>
					}
					children={
						<div className="flex w-36 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
							<div className="p-4">
								<div className="flex items-center gap-2">
									<p className="text-sm font-bold text-navy-700 dark:text-white">
										Hey, {users.name}
									</p>
								</div>
							</div>
							<div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

							<div className="flex flex-col p-4">
								<div
									onClick={handleLogout}
									className="cursor-pointer text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in"
								>
									Logout
								</div>
							</div>
						</div>
					}
					classNames={"py-2 top-10 right-0 w-max"}
				/>
			</div>
		</nav>
	);
};

export default Navbar;
